import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { getPaymentMethodsUsed, calculateKokoChargeForSplit, calculateMintPayChargeForSplit } from '../firebase/paymentSplitService';

/**
 * Display payment split information as a badge/chip
 * Shows individual payment methods and amounts
 */
const PaymentSplitBadge = ({ paymentSplit, billingSettings = {}, variant = 'outlined' }) => {
  if (!paymentSplit || Object.values(paymentSplit).filter(v => v > 0).length <= 1) {
    return null; // Don't show if no split or only one method
  }

  const methods = getPaymentMethodsUsed(paymentSplit);
  const kokoCharge = calculateKokoChargeForSplit(paymentSplit.koko, billingSettings?.kokoChargePercentage || 12);
  const mintPayCharge = calculateMintPayChargeForSplit(paymentSplit.mintpay, billingSettings?.mintPayChargePercentage || 12);

  const tooltipContent = (
    <Box sx={{ p: 1 }}>
      <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
        Payment Split:
      </Typography>
      {methods.map(m => (
        <Typography key={m.method} variant="caption" display="block">
          {m.label}: {m.amount.toFixed(2)}
        </Typography>
      ))}
      {kokoCharge > 0 && (
        <Typography variant="caption" display="block" sx={{ mt: 0.5, color: '#ff9800' }}>
          Koko Charge: +{kokoCharge.toFixed(2)}
        </Typography>
      )}
      {mintPayCharge > 0 && (
        <Typography variant="caption" display="block" sx={{ mt: 0.5, color: '#ff9800' }}>
          MintPay Charge: +{mintPayCharge.toFixed(2)}
        </Typography>
      )}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent}>
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
        {methods.map(m => (
          <Chip
            key={m.method}
            label={`${m.label}: ${m.amount.toFixed(2)}`}
            size="small"
            variant={variant}
            color={m.method === 'koko' || m.method === 'mintpay' ? 'warning' : 'primary'}
            sx={{
              fontSize: '0.75rem',
              height: '24px',
            }}
          />
        ))}
      </Box>
    </Tooltip>
  );
};

export default PaymentSplitBadge;
